import React from 'react';

import { Container, Document, Header, Meta, Section } from '../InformationSecurityPolicy/styles';

const Privacy: React.FC = () => {
	return (
		<Container>
			<Document>
				<Header>
					<p>Razio Digital</p>
					<h1>Política de Privacidade</h1>
					<Meta>Última atualização: 19 de outubro de 2026</Meta>
				</Header>

				<Section>
				<h2>
					1. Informações Coletadas
				</h2>
				<p>
					<strong>1.1.</strong> Informações de Registro: Quando você se cadastra e cria uma conta no aplicativo, podemos coletar informações como nome, endereço de e-mail e senha.
				</p>
				<p>
					<strong>1.2.</strong> Informações de Perfil: O aplicativo pode permitir que você crie um perfil, incluindo informações como foto de perfil, descrição e informações de contato.
				</p>
				<p>
					<strong>1.3.</strong> Informações de Uso: Coletamos informações sobre como você utiliza o aplicativo, como suas interações com as ferramentas de pintura, suas preferências e atividades dentro do aplicativo.
				</p>

				<p>
					<strong>1.4.</strong> Informações de Dispositivo: Podemos coletar informações sobre o seu dispositivo, incluindo tipo de dispositivo, sistema operacional, identificadores únicos e informações de rede.
				</p>
				</Section>

				<Section>
				<h2>2. Uso das Informações</h2>
				<p>
					<strong>2.1.</strong> Fornecimento de Serviços: Utilizamos as informações coletadas para fornecer os serviços do aplicativo, incluindo funcionalidades de pintura e interações sociais entre os usuários.
				</p>
				<p>
					<strong>2.2.</strong> Melhoria do Aplicativo: Analisamos as informações coletadas para melhorar a qualidade do aplicativo, ajustar recursos com base no feedback dos usuários e otimizar a experiência geral.
				</p>
				<p>
					<strong>2.3.</strong> Comunicações: Podemos enviar e-mails ou notificações sobre atualizações do aplicativo, novos recursos, conteúdo relevante e comunicações administrativas.
				</p>

				<p>
					<strong>2.4.</strong> Análises e Pesquisas: Podemos realizar análises de dados para entender melhor o comportamento dos usuários e realizar pesquisas para melhorar os nossos serviços.
				</p>
				</Section>

				<Section>
				<h2>3. Compartilhamento de Informações</h2>
				<p>
					<strong>3.1.</strong> Compartilhamento entre Usuários: Algumas informações de perfil e atividades podem ser compartilhadas com outros usuários do aplicativo, de acordo com as configurações de privacidade escolhidas por você.
				</p>
				<p>
					<strong>3.2.</strong> Parceiros e Prestadores de Serviços: Podemos compartilhar informações com parceiros e prestadores de serviços que nos auxiliam na operação e no desenvolvimento do aplicativo.
				</p>
				<p>
					<strong>3.3.</strong> Requisitos Legais: Podemos compartilhar informações pessoais em resposta a solicitações legais, cumprimento de obrigações regulatórias ou para proteger os direitos, propriedade ou segurança do aplicativo, de nossos usuários ou de terceiros.
				</p>
				</Section>

				<Section>
				<h2>4. Segurança das Informações</h2>
				<p>
					Implementamos medidas de segurança adequadas para proteger as informações pessoais dos usuários. No entanto, nenhum método de transmissão ou armazenamento eletrônico é completamente seguro. Não podemos garantir a segurança absoluta das informações.
				</p>
				</Section>

				<Section>
				<h2>5. Seus Direitos e Escolhas</h2>
				<p>
					<strong>5.1.</strong> Acesso e Atualização: Você pode acessar e atualizar as informações do seu perfil a qualquer momento nas configurações do aplicativo.
				</p>
				<p>
					<strong>5.2.</strong> Exclusão da Conta: Você pode solicitar a exclusão da sua conta, o que resultará na remoção das informações associadas a ela, sujeito a retenções necessárias por obrigações legais.
				</p>
				<p>
					<strong>5.3.</strong> Configurações de Privacidade: O aplicativo pode oferecer opções para controlar o compartilhamento de suas informações com outros usuários.
				</p>
				</Section>

				<Section>
				<h2>6. Menores de Idade</h2>
				<p>
					O aplicativo não é direcionado a menores de idade. Não coletamos intencionalmente informações pessoais de menores de 18 anos. Caso tenhamos conhecimento de que informações pessoais de um menor foram coletadas sem consentimento dos pais ou responsáveis, tomaremos medidas para remover essas informações.
				</p>
				</Section>

				<Section>
				<h2>7. Alterações na Política de Privacidade</h2>
				<p>
					Podemos atualizar esta Política de Privacidade ocasionalmente para refletir mudanças nas práticas de privacidade. As atualizações serão divulgadas no aplicativo e a data da última atualização será modificada.
				</p>
				</Section>

				<Section>
				<h2>8. Contato</h2>
				<p>
					Se você tiver dúvidas, preocupações ou solicitações relacionadas à privacidade, entre em contato conosco através do atendimento@razio.com.br
				</p>
				<p>
					Esta Política de Privacidade foi elaborada para fornecer informações claras sobre como tratamos suas informações pessoais. Ao utilizar o aplicativo "Pintor 10", você concorda com as práticas descritas nesta política.
				</p>
				</Section>

			</Document>
		</Container>
	)
}

export default Privacy;
